export enum ProcessMasterDatasetRunPayloadKeys {
  runId = 'runId',
  uploadActionId = 'uploadActionId',
}

export interface ProcessMasterDatasetRunPayload {
  [ProcessMasterDatasetRunPayloadKeys.runId]: string;
  [ProcessMasterDatasetRunPayloadKeys.uploadActionId]: string;
}
